import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AngleDown from '../icons/AngleDown';
import Api from '../../services/Api';
import { withCartConfig } from '../../hooks/CartConfigContext';

const StorefrontCarriers = props => {
    const [storefrontCarriers, setStorefrontCarriers] = React.useState([]);
    const [carrier1, setCarrier1] = React.useState(props.storefrontCarrierId.length > 0 ? props.storefrontCarrierId : "");
    const [carrier2, setCarrier2] = React.useState(props.storefrontCarrier2Id.length > 0 ? props.storefrontCarrier2Id : "");
    const isStateNLE = props.selectedCustomer?.address?.state === "NLE" || false;
    const useDefaultCarrier = props.useDefaultCarrier === "1" ? true : false;
    const carriersEnabled = () => {
        return props.CartConfig.childComponents.Carrier1.shown === true || props.CartConfig.childComponents.Carrier2.shown === true;
    };

    useEffect(() => {
        const loadStorefrontCarriers = async () => {
            if (carriersEnabled()) {
                try {
                    const resCarriers = await Api.fetch(`/api/customer/${props.selectedCustomer.id}/carriers`);
                    if (resCarriers) {
                        setStorefrontCarriers(resCarriers);
                    }
                } catch (error) {
                    console.error("Error fetching carriers:", error);
                }
            }
        };

        loadStorefrontCarriers();
    }, [props.selectedCustomer.id]);

    useEffect(() => {
        const normalizeCarrierId = (v) => {
            if (v === null || v === undefined) return "";
            const s = String(v).trim();
            return (s === "" || s === "0") ? "" : s;
        };
        const applyCarrier = (id) => {
            if (!id) return;
            setCarrier1(id);
            props.updateCarriers({ carrier1: id, carrier2 });
        };
        const getCarrierIdByName = (name) =>
            String(
                storefrontCarriers.find(
                    (item) => item.name?.trim().toUpperCase() === name
                )?.id ?? ""
            );
        if (storefrontCarriers.length > 0) {
            let carrierId = normalizeCarrierId(props.selectedCustomer?.carrierId)
            if (isStateNLE) {
                carrierId = getCarrierIdByName("LOCAL");
                applyCarrier(carrierId);
            } else if (props.automaticFreightCode === "CP1") {
                carrierId = getCarrierIdByName("PAQUETE EXPRESS");
                applyCarrier(carrierId);
            } else if (useDefaultCarrier) {
                applyCarrier(carrierId);
            }
        }
    }, [storefrontCarriers, isStateNLE, props.automaticFreightCode, carrier2]);

    const isCarrier1Disabled = isStateNLE || props.automaticFreightCode === "CP1" ? true : false;

    const handleChange = (e) => {
        setCarrier1(e.target.value);
        props.updateCarriers({ carrier1: e.target.value, carrier2: carrier2 });
    }

    const handleCarrier2Change = (e) => {
        setCarrier2(e.target.value);
        props.updateCarriers({ carrier1: carrier1, carrier2: e.target.value });
    }

    const { localized } = props;
    return (
        <>
            {carriersEnabled() && storefrontCarriers && storefrontCarriers.length > 0 &&
                <div className="section">
                    <div className="heading3">
                        {localized.StorefrontCarriersLabel}
                    </div>
                    <div className="fele-cart-storefront-carriers">
                        <div className="fele-content">
                            <div className="input-wrapper">
                                {
                                    props.CartConfig.childComponents.Carrier1.shown === true &&
                                    <div className="select-wrapper">
                                                    <select onChange={handleChange} value={carrier1} disabled={isCarrier1Disabled}>
                                            <option value="" style={{ color: 'gray' }}>{localized.SelectACarrier}</option>
                                            {
                                                storefrontCarriers.map(
                                                    (storefrontCarrier, index) =>
                                                        <option key={index} value={storefrontCarrier.id}>{storefrontCarrier.name}</option>
                                                )}</select>
                                        <AngleDown />
                                    </div>
                                }
                                {
                                    props.CartConfig.childComponents.Carrier2.shown === true &&
                                    <div className="select-wrapper">
                                        <select onChange={handleCarrier2Change} value={carrier2}>
                                            <option value="" style={{ color: 'gray' }}>{localized.SelectACarrier2}</option>
                                            {
                                                storefrontCarriers.map(
                                                    (storefrontCarrier, index) =>
                                                        <option key={index} value={storefrontCarrier.id}>{storefrontCarrier.name}</option>
                                                )}</select>
                                        <AngleDown />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

StorefrontCarriers.propTypes = {
    carriersUpdated: PropTypes.func,
    selectedCustomer: PropTypes.object,
    storefrontCarrierId: PropTypes.string,
    storefrontCarrier2Id: PropTypes.string,
    updateCarriers: PropTypes.func,
};

export default withCartConfig(StorefrontCarriers);